import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { OrgStatus } from '@/shared/domain'
import type { LoadOrgStatus } from '@/modules/auth/use-cases'

export class EdgeLoadOrgStatusRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadOrgStatus = async () => {
    const request: HttpRequest<never> = { url: '/members/org-status' }
    return this.httpClient.get<OrgStatus>(request)
  }
}
